import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './shiftAccumulationTypeChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'afioaeppppjoep'}
})
export class ShiftAccumulationTypeChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalShiftAccumulationTypes: any;
    
    public shiftAccumulationTypes: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("shift_accumulation_types/update_order", { shift_accumulation_type_ids: this.shiftAccumulationTypes.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.shiftAccumulationTypes, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.shiftAccumulationTypes = JSON.parse(JSON.stringify(this.originalShiftAccumulationTypes));
    }
}
